'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = formatCurrency;

var _memoize = require('lodash/memoize');

var _memoize2 = _interopRequireDefault(_memoize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a formatter for the given currency.
 *
 * @param  {string} currency
 * @return {Intl.NumberFormat}
 */
var formatterFor = function formatterFor(currency) {
  return new Intl.NumberFormat('en-US', { currency: currency, style: 'currency' });
};

// Memoizes formatter instances.
formatterFor = (0, _memoize2.default)(formatterFor);

/**
 * Formats the given value for the specified currency.
 *
 * @param  {Number} value
 * The value to format.
 *
 * @param  {string} currency
 * The currency to format as. Defaults to usd.
 *
 * @return {string}
 * The formatted currency.
 */
function formatCurrency(value) {
  var currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'usd';

  return formatterFor(currency).format(value);
}
//# sourceMappingURL=formatCurrency.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/utils/formatCurrency.js
// module id = 155
// module chunks = 0